import { render, staticRenderFns } from "./editgrp.vue?vue&type=template&id=182cf7da&scoped=true&"
import script from "./editgrp.vue?vue&type=script&lang=js&"
export * from "./editgrp.vue?vue&type=script&lang=js&"
import style0 from "./editgrp.vue?vue&type=style&index=0&id=182cf7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cf7da",
  null
  
)

export default component.exports